import { DynamicCodeBlock } from 'cms-types'
import { DynamicCode as UIDynamicCode } from 'ui'

export default function DynamicCode(props: DynamicCodeBlock) {
  return <UIDynamicCode {...props} />
}
